module.exports = __webpack_public_path__ + "cancellara-live-dist/img/logo-footer.4c7aa272.svg";